import { isTRPCClientError } from "@trpc/client"

import type { MainRouter } from "../../../backend/src/routers/trpc/trpcRouter"

/** True when the backend answered NOT_FOUND, for example for a session id that does not exist. */
export function isNotFoundError(error: unknown) {
  return isTRPCClientError<MainRouter>(error) && error.data?.code === "NOT_FOUND"
}
